export const SQFT_IN_ACRE = 43560

export const STATE_ABBREVIATIONS = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FM: 'Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number]

/** The different windows, in days, we create guest card conversion metrics for */
export const GUESTCARD_CONVERSION_WINDOWS = [1, 7, 14, 30, 60]

// WARNING: These values are in the db (AttributeMappingModelType.normalizedValue), so if you want to
// remove one, you need to migrate the db first.
export enum ChargeCodeNormalizedValue {
  RENT = 'rent',
  RENT_AMENITIES = 'rentAmenities',
  CONCESSION = 'concession',
  CONCESSION_RENEWAL = 'concessionRenewal',
}
// WARNING: These values are in the db (AttributeMappingModelType.normalizedValue), so if you want to
// remove one, you need to migrate the db first.
export enum GuestcardEventResultNormalizedValue {
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  MISSED = 'missed',
  RESCHEDULED = 'rescheduled',
}

export const SCOTT_AIR_SID = 'p932q4zzjfjt'
